module.exports = (__webpack_require__(5))(43);


//////////////////
// WEBPACK FOOTER
// delegated ./src/collections/UserCollection.js from dll-reference girder_plugin_large_image_annotation
// module id = 58
// module chunks = 0